import $ from 'jquery';
import { renderLoader } from '~loader/renderLoader';
import { getState, modifyState } from '~src/state';
import editorConfig from '~config/editorConfig';
import { showAfIntroModal } from '~src/sidebar/annunciFunebri/showAfIntroModal';
import { trackEvent } from '~src/tracking';

export const projectClickHandler = (event) => {
  event.preventDefault();
  event.stopPropagation();

  modifyState('selected.formato', {});
  modifyState('selected.formatoDefault', {});
  modifyState('selected.templatesCategory', {});

  const projectId = $(event.currentTarget).data('project-id');
  const projectEnabled = !!$(event.currentTarget).data('project-enabled');

  // Detect project "Cordogli"
  const afEnabled = getState('af_enabled', false);
  if (!afEnabled && editorConfig.cordogliProjectIds.includes(projectId)) {
    showAfIntroModal();
    trackEvent('Upselling', {
      type: 'click',
      source: 'main menu',
      success: true,
      offer: 'obituaries',
      purpose: 'upselling',
      intent: 'cordogli',
    });
    return;
  }

  if (!projectEnabled) {
    return;
  }

  const project = window.editorLoader.projects.items.find(
    (project) => project.objectId === projectId
  );

  $('[data-project-id]').removeClass('block-selected block-default');

  $(event.currentTarget).addClass('block-selected');

  window.urlParams.set('tipo', projectId);

  window.history.replaceState(
    {},
    '',
    `${window.location.href.split('?')[0]}?` + window.urlParams
  );

  modifyState('selected.tipo', project);

  window.editorLoader.createNew = false;

  setTimeout(async () => {
    await renderLoader();
  }, 0);
};
